import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	searchData: {
		enrollmentRequestStatuses: [
			{
				id: "",
				siteId: "",
				name: "",
				description: "",
				isReadOnly: true,
				isInitial: false,
				isFinal: false,
				isApproved: false,
				isHandled: false,
			},
		],
		enrollmentStatuses: [
			{
				id: "",
				siteId: "",
				nome: "",
				externalId: null,
			},
		],
		trainingTypes: [
			{
				display: "",
				id: "",
			},
		],
		modalities: [
			{
				id: "",
				Code: "",
				name: "",
			},
		],
	},
	enrolledData: [
		{
			trainingType: "",
			modalityId: "",
			modality: {
				id: "",
				Code: "",
				name: "",
			},
			id: "",
			code: "",
			name: "",
			startDate: "",
			startDateStr: "",
			endDate: "",
			endDateStr: "",
			duration: 0,
			durationSpan: "",
		},
	],
	completedData: [
		{
			id: "",
			code: "",
			name: "",
			startDate: "",
			shortStartDate: "",
			endDate: "",
			shortEndDate: "",
			completionDate: null,
			shortCompletionDate: null,
			duration: "",
			durationSpan: "",
			grade: "",
			isCertificateAvailable: false,
			trainingType: "",
			modality: {
				id: "",
				Code: "",
				name: "",
			},
			enrollmentStatus: {
				id: "",
				siteId: "",
				nome: "",
				externalId: null,
			},
		},
	],
	requestsData: [
		{
			id: "",
			targetTrainingId: "",
			targetTrainingName: "",
			requestDate: "",
			requestDateStr: "",
			approvalDate: null,
			approvalDateStr: null,
			enrollmentStatusId: "",
			trainingType: "",
			enrollmentRequestStatus: {
				id: "",
				siteId: "",
				name: "",
				description: "",
				isReadOnly: true,
				isInitial: false,
				isFinal: false,
				isApproved: false,
				isHandled: false,
			},
		},
	],
};

const MyCoursesSlice = createSlice({
	name: "MyCourses",
	initialState: initialState,
	reducers: {
		updateSearchData(state, action) {
			console.log("update MyCourses updateSearchData");
			console.log(action);

			state.searchData = action.payload;
		},
		updateEnrolledData(state, action) {
			console.log("update MyCourses EnrolledData");
			console.log(action);

			state.enrolledData = action.payload;
		},
		updateCompletedData(state, action) {
			console.log("update MyCourses CompletedData");
			console.log(action);

			state.completedData = action.payload;
		},
		updateRequestsData(state, action) {
			console.log("update MyCourses RequestsData");
			console.log(action);

			state.requestsData = action.payload;
		},
	},
});

export const MyCoursesActions = MyCoursesSlice.actions;

export default MyCoursesSlice;
